export default __webpack_public_path__ + "static/media/vmou.e15ac26a.png";